import { render, staticRenderFns } from "./family_form.vue?vue&type=template&id=e7fa3404"
import script from "./family_form.vue?vue&type=script&lang=js"
export * from "./family_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports